import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Pill, SectionHeader } from 'web-library';
import Icon, { IconName } from 'web-library/stories/atom/Icon/Icon';



import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
  },
  noticeBoardIcon: {
    color: theme.color.text.textHeader,
  },
  swiperButtons: {
    paddingTop: theme.spacing(3),
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row-reverse'!,
  },
  swiperButton: {
    color: theme.color.icon.iconSelected,
  },
  disabledSwiperButton: {
    color: theme.color.icon.iconDisabled,
  },
}));

interface UpcomingSubjectPapersHeaderProps {
  totalUpcomingSubjectPapers: number;
  isDesktopView: boolean;
  isFirstPage: boolean;
  isEndPage: boolean;
}

const UpcomingSubjectPapersHeader = ({
  totalUpcomingSubjectPapers,
  isDesktopView,
  isFirstPage,
  isEndPage,
}: UpcomingSubjectPapersHeaderProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header}>
      <Box className={classes.titleContainer}>
        <SectionHeader title={t('admin->>UpcomingSubjectPapers.UpcomingSubjectPapers')} />
        <Box marginTop={2}>
          <Pill label={`${totalUpcomingSubjectPapers}`} variant="info" />
        </Box>
      </Box>
      {isDesktopView && totalUpcomingSubjectPapers !== 0 && (
        <Box className={classes.swiperButtons}>
          <Icon
            size="M"
            className={
              isEndPage
                ? `${classes.swiperButton} nextButton ${classes.disabledSwiperButton}`
                : `${classes.swiperButton} nextButton`
            }
            name={IconName.arrowRight}
          />
          <Icon
            size="M"
            className={
              isFirstPage
                ? `${classes.swiperButton} prevButton ${classes.disabledSwiperButton}`
                : `${classes.swiperButton} prevButton`
            }
            name={IconName.arrowLeft}
          />
        </Box>
      )}
    </Box>
  );
};

export default UpcomingSubjectPapersHeader;
